import React from "react";
import { useState } from "react";
import { api } from "api";

/**
 * Hook para obtener las fincas de un proveedor
 * @returns {Object} - Objeto con las funciones para obtener las fincas de un proveedor y el estado de carga
 */
export const FincasApi = () => {
    const [cargando, setCargando] = useState(false);

    // FINCAS PROVEEDOR
    const [fincasProveedor, setFincasProveedor] = useState([]);

    const getFincasProveedorForSelect = async (proveedorId = undefined) => {
        setFincasProveedor([]);

        try {
            setCargando(true);
            const response = await api.get("recepcion/get_fincas_proveedores", {
                proveedor_id: proveedorId,
            });
            if (!response.results) return [];
            const data = response.results;
            const dataForSelect = data.map((finca) => ({
                value: finca.id,
                label: finca.nombre,
            }));

            setFincasProveedor(dataForSelect);
            return dataForSelect;
        } catch (error) {
            console.error(error);
            setFincasProveedor([]);
            return [];
        } finally {
            setCargando(false);
        }
    };

    return {
        getFincasProveedorForSelect,
        fincasProveedor,

        cargando,
    };
};
